export const state = () => ({
  events: [],
  employees: [],
})

export const mutations = {
  setEmployees: (state, value) => (state.employees = value),
  setEvents: (state, value) => (state.events = value),
  setEventStatus: (state, value) => {
    state.events = state.events.map(event => {
      if (event.id === value.id) {
        return {
          ...event,
          status: value.status,
        }
      }
      return event
    })
  },
  updateEvent: (state, value) => {
    state.events = state.events.map(event => {
      if (event.id === value.id) {
        return {
          ...event,
          ...value,
        }
      }
      return event
    })
  },
  addEvent: (state, value) => {
    state.events = [...state.events, value]
  },
  deleteEvent: (state, value) => {
    state.events = state.events.filter(event => event.id !== value.id)
  },
  updateEventPresence: (state, value) => {
    const { id, employeeCode, status } = value
    const setByPresenceStatus = {
      maybe: () => {
        state.events = state.events.map(event => {
          if (event.id === id) {
            return {
              ...event,
              confirmedEmployeesCode: event.confirmedEmployeesCode?.filter(
                code => code !== employeeCode
              ),
              declinedEmployeesCode: event.declinedEmployeesCode?.filter(
                code => code !== employeeCode
              ),
            }
          }
          return event
        })
      },
      confirm: () => {
        state.events = state.events.map(event => {
          if (event.id === id) {
            return {
              ...event,
              confirmedEmployeesCode: [
                ...event.confirmedEmployeesCode,
                employeeCode,
              ],
              declinedEmployeesCode: event.declinedEmployeesCode?.filter(
                code => code !== employeeCode
              ),
            }
          }
          return event
        })
      },
      decline: () => {
        state.events = state.events.map(event => {
          if (event.id === id) {
            return {
              ...event,
              declinedEmployeesCode: [
                ...event.declinedEmployeesCode,
                employeeCode,
              ],
              confirmedEmployeesCode: event.confirmedEmployeesCode?.filter(
                code => code !== employeeCode
              ),
            }
          }
          return event
        })
      },
    }
    setByPresenceStatus[status]()
  },
}

export const actions = {
  async fetchEvents({ commit }, employeeCode) {
    try {
      const { data } = await this.$axios.get(`/v3/app/calendar/${employeeCode}`)
      const newValue = data.events.map(event => ({
        ...event,
        id: event._id,
      }))
      commit('setEvents', newValue)
      commit('setEmployees', data.employees)
    } catch (error) {
      throw error
    }
  },
  async updateEventStatus({ commit }, { id, status }) {
    commit('setEventStatus', { id, status })
    try {
      await this.$axios.put(`/v3/app/calendar/status/${id}`, { status })
    } catch (error) {
      const rollbackStatus = {
        waiting: 'finished',
        finished: 'waiting',
      }
      commit('setEventStatus', { id, status: rollbackStatus[status] })
      console.error(error)
      throw error
    }
  },
  async updateEvent({ commit, state }, value) {
    const oldValue = {
      ...state.events.filter(event => event.id === value.id)[0],
    }
    commit('updateEvent', value)
    try {
      await this.$axios.put(`/v3/app/calendar/${value._id}`, value)
    } catch (error) {
      commit('updateEvent', oldValue)
      console.error(error)
      throw error
    }
  },
  async deleteEvent({ commit }, value) {
    commit('deleteEvent', value)
    try {
      await this.$axios.delete(`/v3/app/calendar/${value._id}`)
    } catch (error) {
      commit('addEvent', value)
      console.error(error)
      throw error
    }
  },
  async updateEventPresence({ commit, state }, { id, employeeCode, status }) {
    const oldEvent = state.events.filter(event => event.id === id)[0]
    commit('updateEventPresence', { id, employeeCode, status })
    try {
      await this.$axios.put(`/v3/app/calendar/presence/${id}`, {
        presenceStatus: status,
      })
    } catch {
      commit('updateEvent', oldEvent)
      console.error(error)
      throw error
    }
  },
}
